var domain = 'https://beacon-v2.helpscout.net';
/* eslint-disable */

var loadScript = function loadScript() {
  if (window.Beacon) return false;

  (function (e, t, n) {
    function a() {
      var _e$parentNode;

      var e = t.getElementsByTagName('script')[0],
          n = t.createElement('script');
      n.async = !0, n.src = domain, (_e$parentNode = e.parentNode) === null || _e$parentNode === void 0 ? void 0 : _e$parentNode.insertBefore(n, e);
    }

    if (e.Beacon = n = function n(t, _n, a) {
      e.Beacon.readyQueue.push({
        method: t,
        options: _n,
        data: a
      });
    }, n.readyQueue = [], 'complete' === t.readyState) return a();
    e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1);
  })(window, document, window.Beacon || function () {});

  return true;
};
/* eslint-enable */


var load = function load(_ref) {
  var providerKey = _ref.providerKey,
      setState = _ref.setState,
      _ref$beforeInit = _ref.beforeInit,
      beforeInit = _ref$beforeInit === void 0 ? function () {
    return undefined;
  } : _ref$beforeInit,
      _ref$onReady = _ref.onReady,
      onReady = _ref$onReady === void 0 ? function () {
    return undefined;
  } : _ref$onReady;
  var loaded = loadScript(); // Continue as long as helpscout hasn’t already been initialised.

  if (loaded) {
    beforeInit();
    window.Beacon('init', providerKey);
    window.Beacon('once', 'ready', function () {
      return (// Allow helpscout to complete loading before removing fake widget
        setTimeout(function () {
          setState('complete');
          onReady();
        }, 2000)
      );
    });
  }

  return loaded;
};

var open = function open() {
  return window.Beacon('open');
};

export default {
  domain: domain,
  load: load,
  open: open
};